angular.module('screensApp', [
	'config',
	'LocalStorageModule',
	'tmh.dynamicLocale',
	'ngResource',
	'ui.router',
	'ngCookies',
	'pascalprecht.translate',
	'ngCacheBuster',
	'ngRequestCacheDisabler',
	'xml',
	'ngSanitize',
	'com.2fdevs.videogular',
	'ja.qr'
])

	.run(function ($rootScope, $window, $http, $state, $translate, $templateCache, Language, Environment, Config, LocalConfigUrl, Translation) {
		// Environment
		$rootScope.ENV = Environment.name;
		$rootScope.VERSION = Environment.version;

		$rootScope.getConfigFromNative = function() {
			try {
				Native.Config = InitializeScreenApp();
				if (!angular.equals({}, Native.Config)) {
					Native.Config = JSON.parse(Native.Config);
				}
				return true;
			} catch (err) {
				console.log('# ERROR: getConfigFromNative() Environment: ' + $rootScope.ENV + ' Native Config: ' + JSON.stringify(Native.Config));
				return false;
			}
		}
		Native = {
			Config: {}
		};

		$rootScope.getConfig = function() {
			try {
				// Primárne si pýtam Local Config z url settings/screen-???.json, ak má povolené 'ForceLocalConfig' použijem ho
				var xhr = new XMLHttpRequest();
				xhr.open('GET', LocalConfigUrl, false); // false set to synchronous
				xhr.send();
				
				if (xhr.status === 200) {
					try {
						var localConfig = JSON.parse(xhr.responseText);
						// Načítaj Local alebo Native config podľa nastavenia v Local config
						if (localConfig.ForceLocalConfig === true) {
							Config = localConfig; // prestavím 'Config' (z deploy tasku) dáta na načítaný config
							console.log( "%cUsing Local Config:\n",	'background: #333; color: #fff; padding: 2px 5px;', Config);
						} else {
							// načítam config z natívnej aplikácie
							$rootScope.getConfigFromNative();
						}
					} catch(err) {
						// načítam config z natívnej aplikácie
						$rootScope.getConfigFromNative();
						console.warn('Error fetching Local Config:\n',err);
					}
				} else {
					// načítam config z natívnej aplikácie
					$rootScope.getConfigFromNative();
					console.warn('Error fetching Local Config:\n', xhr.statusText);
				}
			} catch(err) {
				// ak sa niečo pokazilo načítam config z natívnej aplikácie
				$rootScope.getConfigFromNative();
				console.error('Error fetching Config\n', err);
			}
		};

		/**
		 * Odchytenie onerror pri nacitavani obrazka
		 * @returns {string} imagePath - Relativna cesta lokalizovaneho banner obrazka
		 */
		getDefaultBannerRelativePath = function() {
			// Z global scope dopytuje $rootScope angular parameter '$rootScope.url.DefaultErrorBanner', inak vrati univerzalny path k obrazku 'DOXXbet'
			// $rootScope moze byt nedostupny pocas inicializacie
			return angular.element(document.body)?.scope()?.$root?.url?.DefaultErrorBanner || 'images/default-banner.jpg';
		}

		$rootScope.getConfig();

		console.log('# INFO: Native Config: ' + JSON.stringify(Native.Config));
		
		// Config
		$rootScope.config = {};
		$rootScope.config.Country = (typeof Native.Config.Country !== "undefined")? Native.Config.Country.toUpperCase(): Config.Country;
		$rootScope.config.ClientId = (typeof Native.Config.ClientId !== "undefined")?Native.Config.ClientId: Config.ClientId;
		$rootScope.config.SbId = (typeof Native.Config.SbId !== "undefined")? Native.Config.SbId: Config.SbId;
		$rootScope.config.Level = (typeof Native.Config.Level !== "undefined")? Native.Config.Level: Config.Level;
		$rootScope.config.TimeZone = (typeof Native.Config.TimeZone !== "undefined")? Native.Config.TimeZone: Config.TimeZone;
		$rootScope.config.LanguageId = (typeof Native.Config.LanguageId !== "undefined")? Native.Config.LanguageId: Config.LanguageId;
		$rootScope.config.LanguageIdDefault = (typeof Native.Config.LanguageIdDefault !== "undefined")? Native.Config.LanguageIdDefault: Config.LanguageIdDefault;
		$rootScope.config.CurrencyId = (typeof Native.Config.CurrencyId !== "undefined")? Native.Config.CurrencyId: Config.CurrencyId;
		$rootScope.config.DemoLabelAllowed = (typeof Native.Config.DemoLabelAllowed !== "undefined")? Native.Config.DemoLabelAllowed: Config.DemoLabelAllowed;
		$rootScope.config.CountryFeed = (typeof Native.Config.CountryFeed !== "undefined")? Native.Config.CountryFeed: Config.CountryFeed;
		$rootScope.config.OddsCacheFeed = (typeof Native.Config.OddsCacheFeed !== "undefined")? Native.Config.OddsCacheFeed: Config.OddsCacheFeed;
		$rootScope.config.JackpotBetTypes = (typeof Native.Config.JackpotBetTypes !== "undefined")? Native.Config.JackpotBetTypes: Config.JackpotBetTypes;
		$rootScope.config.JackpotBetPlatforms = (typeof Native.Config.JackpotBetPlatforms !== "undefined")? Native.Config.JackpotBetPlatforms: Config.JackpotBetPlatforms;
		$rootScope.config.JackpotStyle = (typeof Native.Config.JackpotStyle !== "undefined")? Native.Config.JackpotStyle: Config.JackpotStyle;
		$rootScope.config.OfferOddsCacheCustomerID = (typeof Native.Config.OfferOddsCacheCustomerID !== "undefined")? Native.Config.OfferOddsCacheCustomerID: Config.OfferOddsCacheCustomerID;
		$rootScope.config.MediaDisableProtectionTime = (typeof Native.Config.MediaDisableProtectionTime !== "undefined")? Native.Config.MediaDisableProtectionTime: Config.MediaDisableProtectionTime;

		// Config	Biometry										Switch for login by camera
		//			BiometryAppearanceVersion 						Design during login - "CameraInCircle", "CameraInCircleTransparent", "CameraInCircleWhite", "CameraInCircleRight", "CameraInCircleLeft", "CameraInCircleHints"
		//			BiometryCandidateSelectionDuration				Duration of automated process attempting to capture multiple valid images and selects the best one from them during login by face
		//			BiometryFrontCamera 							Enabled - "user", Disabled - "environment"
		//			BiometryBatchCount 								Image count restriction during login
		//			BiometryMaxFaceDetectionTime 					Timeout for login by camera

		// Config	Biometry Thresholds
		//			BiometryFaceConfidence 							Detection confidence threshold 												<0, 1>
		//			BiometrySharpnessThreshold 						Low sharpness threshold for login by camera 								<0, 1>
		//			BiometryBrightnessLowThreshold 					Low brightness threshold 													<0, 1>
		//			BiometryBrightnessHighThreshold 				High brightness threshold 													<0, 1>
		//			BiometryOutOfBoundsThreshold 					Face out of bounds threshold 												<-1, 1>
		//			BiometryMinFaceSizeRatio 						Minimum face size ratio relative to shorter side of the camera resolution 	<0, 1>
		//			BiometryMaxFaceSizeRatio 						Maximum face size ratio relative to shorter side of the camera resolution 	<0, 1>
		//			BiometryDevicePitchAngleThreshold 				Maximum and minimum device pitch angle in degrees 							[degree]
		$rootScope.config.BiometryLogin = (typeof Native.Config.BiometryLogin !== "undefined")? Native.Config.BiometryLogin: Config.BiometryLogin;
		$rootScope.config.BiometryAppearanceVersion = (typeof Native.Config.BiometryAppearanceVersion !== "undefined")? Native.Config.BiometryAppearanceVersion: Config.BiometryAppearanceVersion;
		$rootScope.config.BiometryCandidateSelectionDuration = (typeof Native.Config.BiometryCandidateSelectionDuration !== "undefined")? Native.Config.BiometryCandidateSelectionDuration: Config.BiometryCandidateSelectionDuration;
		$rootScope.config.BiometryFrontCamera = (typeof Native.Config.BiometryFrontCamera !== "undefined")? Native.Config.BiometryFrontCamera: Config.BiometryFrontCamera;
		$rootScope.config.BiometryBatchCount = (typeof Native.Config.BiometryBatchCount !== "undefined")? Native.Config.BiometryBatchCount: Config.BiometryBatchCount;
		$rootScope.config.BiometryMaxFaceDetectionTime = (typeof Native.Config.BiometryMaxFaceDetectionTime !== "undefined")? Native.Config.BiometryMaxFaceDetectionTime: Config.BiometryMaxFaceDetectionTime;
		$rootScope.config.BiometryFaceConfidence = (typeof Native.Config.BiometryFaceConfidence !== "undefined")? Native.Config.BiometryFaceConfidence: Config.BiometryFaceConfidence;
		$rootScope.config.BiometrySharpnessThreshold = (typeof Native.Config.BiometrySharpnessThreshold !== "undefined")? Native.Config.BiometrySharpnessThreshold: Config.BiometrySharpnessThreshold;
		$rootScope.config.BiometryBrightnessLowThreshold = (typeof Native.Config.BiometryBrightnessLowThreshold !== "undefined")? Native.Config.BiometryBrightnessLowThreshold: Config.BiometryBrightnessLowThreshold;
		$rootScope.config.BiometryBrightnessHighThreshold = (typeof Native.Config.BiometryBrightnessHighThreshold !== "undefined")? Native.Config.BiometryBrightnessHighThreshold: Config.BiometryBrightnessHighThreshold;
		$rootScope.config.BiometryOutOfBoundsThreshold = (typeof Native.Config.BiometryOutOfBoundsThreshold !== "undefined")? Native.Config.BiometryOutOfBoundsThreshold: Config.BiometryOutOfBoundsThreshold;
		$rootScope.config.BiometryMinFaceSizeRatio = (typeof Native.Config.BiometryMinFaceSizeRatio !== "undefined")? Native.Config.BiometryMinFaceSizeRatio: Config.BiometryMinFaceSizeRatio;
		$rootScope.config.BiometryMaxFaceSizeRatio = (typeof Native.Config.BiometryMaxFaceSizeRatio !== "undefined")? Native.Config.BiometryMaxFaceSizeRatio: Config.BiometryMaxFaceSizeRatio;
		$rootScope.config.BiometryDevicePitchAngleThreshold = (typeof Native.Config.BiometryDevicePitchAngleThreshold !== "undefined")? Native.Config.BiometryDevicePitchAngleThreshold: Config.BiometryDevicePitchAngleThreshold;

		// Config	BiometryOnboarding								Switch for registration by camera (onboarding)

		// Config	BiometryOnboarding Thresholds
		//			BiometryOnboardingDocumentSharpnessThreshold 	Low sharpness threshold for document image autocapture during onboarding
		//			BiometryOnboardingSelfieSharpnessThreshold		Low sharpness threshold for selfie image autocapture during onboarding
		//			BiometryOnboardingSelfieCandidateSelectionDuration 	Duration of automated process attempting to capture multiple valid images and selects the best one from them during onboarding when selfie phase
		//			BiometryOnboardingDocumentCandidateSelectionDuration	Duration of automated process attempting to capture multiple valid images and selects the best one from them during onboarding when document phase
		$rootScope.config.BiometryOnboarding = (typeof Native.Config.BiometryOnboarding !== "undefined")? Native.Config.BiometryOnboarding: Config.BiometryOnboarding;
		$rootScope.config.BiometryOnboardingDocumentSharpnessThreshold = (typeof Native.Config.BiometryOnboardingDocumentSharpnessThreshold !== "undefined")? Native.Config.BiometryOnboardingDocumentSharpnessThreshold: Config.BiometryOnboardingDocumentSharpnessThreshold;
		$rootScope.config.BiometryOnboardingSelfieSharpnessThreshold = (typeof Native.Config.BiometryOnboardingSelfieSharpnessThreshold !== "undefined")? Native.Config.BiometryOnboardingSelfieSharpnessThreshold: Config.BiometryOnboardingSelfieSharpnessThreshold;
		$rootScope.config.BiometryOnboardingSelfieCandidateSelectionDuration = (typeof Native.Config.BiometryOnboardingSelfieCandidateSelectionDuration !== "undefined")? Native.Config.BiometryOnboardingSelfieCandidateSelectionDuration: Config.BiometryOnboardingSelfieCandidateSelectionDuration;
		$rootScope.config.BiometryOnboardingDocumentCandidateSelectionDuration = (typeof Native.Config.BiometryOnboardingDocumentCandidateSelectionDuration !== "undefined")? Native.Config.BiometryOnboardingDocumentCandidateSelectionDuration: Config.BiometryOnboardingDocumentCandidateSelectionDuration;

		// Config Kiron VisionX
		$rootScope.config.KironVisionXUserName = (typeof Native.Config.KironVisionXUserName !== "undefined")? Native.Config.KironVisionXUserName: Config.KironVisionXUserName;
		$rootScope.config.KironVisionXPassword = (typeof Native.Config.KironVisionXPassword !== "undefined")? Native.Config.KironVisionXPassword: Config.KironVisionXPassword;
		$rootScope.config.KironVisionXKeno = (typeof Native.Config.KironVisionXKeno !== "undefined")? Native.Config.KironVisionXKeno: Config.KironVisionXKeno;
		$rootScope.config.KironVisionXLuckyLoot = (typeof Native.Config.KironVisionXLuckyLoot !== "undefined")? Native.Config.KironVisionXLuckyLoot: Config.KironVisionXLuckyLoot;

		// Config URLs
		$rootScope.url = {};
		$rootScope.url.OfferURL = (typeof Native.Config.OfferURL !== "undefined")? Native.Config.OfferURL: Config.OfferURL;
		$rootScope.url.OfferOddsCacheURL = (typeof Native.Config.OfferOddsCacheURL !== "undefined")? Native.Config.OfferOddsCacheURL: Config.OfferOddsCacheURL;
		$rootScope.url.QuickbetVideoURL = (typeof Native.Config.QuickbetVideoURL !== "undefined")? Native.Config.QuickbetVideoURL: Config.QuickbetVideoURL;
		$rootScope.url.KironURL = (typeof Native.Config.KironURL !== "undefined")? Native.Config.KironURL: Config.KironURL;
		$rootScope.url.StaticURL = (typeof Native.Config.StaticURL !== "undefined")? Native.Config.StaticURL: Config.StaticURL;
		$rootScope.url.AppWidgetURL = (typeof Native.Config.AppWidgetURL !== "undefined")? Native.Config.AppWidgetURL: Config.AppWidgetURL;
		$rootScope.url.AppWidgetVersionVG = (typeof Native.Config.AppWidgetVersionVG !== "undefined")? Native.Config.AppWidgetVersionVG: Config.AppWidgetVersionVG;
		$rootScope.url.GraphicSportboxURL = (typeof Native.Config.GraphicSportboxURL !== "undefined")? Native.Config.GraphicSportboxURL: Config.GraphicSportboxURL;
		$rootScope.url.CentralSBURL = (typeof Native.Config.CentralSBURL !== "undefined")? Native.Config.CentralSBURL: Config.CentralSBURL;
		$rootScope.url.TicketURL = (typeof Native.Config.TicketURL !== "undefined")? Native.Config.TicketURL: Config.TicketURL;
		$rootScope.url.VLCURL = (typeof Native.Config.VLCURL !== "undefined")? Native.Config.VLCURL: Config.VLCURL;
		$rootScope.url.MatchtrackerURL = (typeof Native.Config.MatchtrackerURL !== "undefined")? Native.Config.MatchtrackerURL: Config.MatchtrackerURL;
		$rootScope.url.DefaultErrorBanner = (typeof Native.Config.DefaultErrorBanner !== "undefined")? Native.Config.DefaultErrorBanner: Config.DefaultErrorBanner;
		$rootScope.url.KironVisionXURL = (typeof Native.Config.KironVisionXURL !== "undefined")? Native.Config.KironVisionXURL: Config.KironVisionXURL;

		// Winners
		$rootScope.bannedCountriesForWinners = ["LBR"];
		$rootScope.winnerIndex = 0;

		// Banners
		$rootScope.banners = [];
		$rootScope.slideIndex = 0;
		$rootScope.slideCustomIndex = 0;

		// Translations
		$rootScope.translations = Translation;

		// Biometry camera setup
		$rootScope.config.BiometryFrontCamera = $rootScope.config.BiometryFrontCamera? "user": "environment";

		// Console log enabled/disabled
		$rootScope.config.DebugJsConsoleLogEnabled = (typeof Native.Config.DebugJsConsoleLogEnabled !== "undefined")? Native.Config.DebugJsConsoleLogEnabled: Config.DebugJsConsoleLogEnabled;
		console.log("%cfarm: " + $rootScope.config.Country + ", folder: " + Environment.folder, 'background: #222; color: #bada55; padding: 2px 5px;');

		// Obsah viditeľný na vrchnej obrazovke nad bannermi a video bannermi
		$rootScope.topMostContent = '';

		// Watermark 'DEMO' if SBC currency is set (standard SVK in installing - SVK test device)
		$rootScope.DemoLabelAllowed = $rootScope.config.DemoLabelAllowed && ($rootScope.config.CurrencyId === "S");

		// Camera Health Check and Debug Mode
		$rootScope.config.IsCameraHealthCheckEnabled = (typeof Native.Config.IsCameraHealthCheckEnabled !== "undefined")? Native.Config.IsCameraHealthCheckEnabled: Config.IsCameraHealthCheckEnabled;
		$rootScope.config.EnableCameraHealthCheckDebugMode = (typeof Native.Config.EnableCameraHealthCheckDebugMode !== "undefined")? Native.Config.EnableCameraHealthCheckDebugMode: Config.EnableCameraHealthCheckDebugMode;

		// Settings
		$rootScope.settings = {
			"appInitialized": true,
			"displayWinners": true,											// Display winners row
			"winnersForBanner": true, 										// Display winners on particular banner
			"displaySidebar": true,											// Display sidebar
			"limitAge": true,												// Display 18+
			"hasCompetition": false, 										// Default - No Custom Competition
			"slideDelay": 5000,												// Default delay between banners (5 seconds)
			"winnersRowInterval": 7000,										// Interval for display winners (7 seconds)
			"winnersLoadInterval": 900000,									// Interval for load winners (15 minutes)
			"keysLoadInterval": 600000,										// Interval for load keys (10 minutes)
			"assetSport": "https://asset-sport.cdn.doxxbet.sk/",
			"assetRegion": "https://asset-region.cdn.doxxbet.sk/",
			"assetTeam": "https://asset-team.cdn.doxxbet.sk/medium/",
			"stomp": {
				"url": "/topic/data.banners",
				"winners": "",
				"banners": ""
			},
			"defaultBanner": {												// Default banner
				"show": true,
				"src": getDefaultBannerRelativePath()
			},
			"prematch": {
				"show": false
			},
			"virtuals": {
				"show": false,
				"active": false
			},
			"virtualsEvona": {
				"show": false,												// show compoment
				"active": false, 											// video active
				"playVideoTimeout": 10000,									// Cas medzi betstopom a zaciatkom prehravania evona videa
				"pageTimeout": 60000,										// odpocitavaci cas - zmena zobrazenia vysledky/ponuka
				"hideTimeout": 300000,
				"vgEvonaOfferECT": ["lvgWin", "lvgPlace", "lvgShow"],
			},
			"lottery": {
				"show": false,
				"active": false
			},
			"stream": {
				"show": false,
				"active": false
			},
			"helpSRT": {
				"show": false
			},
			"biometry": {
				"show": false,
				"hideTimeout": 6000,
				"hideTimeoutLong": 11000
			},
			"document": {
				"show": false,
				"hideTimeout": 6000,										// Hide timeout zobrazovania informacii napr. o uspechu skenovania dokumentu (ako dlho sa zobrazi informacia pre hraca)
				"hideTimeoutLong": 60000									// Timeout pre skenovanie prednej/zadnej strany dokumentu (ako dlho umoznime hracovi skenovat dokument)
			},
			"betRadarStats": {
				"bannedSportIDs": [58, 73, 65, 70, 171, 167, 64, 83],
				"actualSeasonID": false,
				"show": false
			},
			"teamAnalysis": {
				"show": false,
				"active": false,
				"hideTimeout": 240000
			},
			"matchTracker": {
				"clientID": "3b40dbd31ba72a4cc707c1a40479d063",
				"statisticsInterval": 8000,
				"show": false,
				"active": false,
				"hideTimeout": 30000
			},
			"jackpot": {
				"show": false,
				"active": false,
				"jackpotWinnersMaxCount": 5,
				"hideTimeout": 90000,
			},
			"quickbet": {
				"show": false
			},
			"analysis": {
				"show": false,
				"active": false,
				"hideTimeout": 30000,
				"statsTabsTimeout": 5000
			},
			"video": {
				"defaultUrl": "",
				"defaultType": "video/mp4",
				"show": false
			},
			"vlc": {
				"show": false
			}
		};

		// Toas Notifications
		$rootScope.toastNotifications = [
			/*{
				"id": "blank",
				"visible": false,
				"text": "",
				"icon": "",
				"cssclass": '',
			}*/
		];

		// Set base URLs (URLs with language)
		$rootScope.setUrls = function() {
			$rootScope.url.CentralSBAnalysisURL = $rootScope.url.CentralSBURL + "sportbox/content/" + $rootScope.config.LanguageId + "/events/";
		}

		// Set Locale based on lang (on app initialization and during runtime)
		$rootScope.setLocale = function(lang) {
			if (lang) {
				moment.locale(lang);
			} else {
				moment.locale($rootScope.config.LanguageId);
			}
			$rootScope.setUrls();
		}
		$rootScope.setLocale();

		// Set offer URL (during runtime)
		$rootScope.setOfferUrl = function(url, noCustomerID) {
			if ($rootScope.config.OddsCacheFeed) {
				// Odds cache feed offer
				if (!noCustomerID) {
					if (url.includes("?")) {
						url += "&CustomerID=" + $rootScope.config.OfferOddsCacheCustomerID;
					} else {
						url += "?CustomerID=" + $rootScope.config.OfferOddsCacheCustomerID;
					}
				}
				return $http.get($rootScope.url.OfferOddsCacheURL + url);
			} else {
				// Basic offer
				return $http.jsonp($rootScope.url.OfferURL + url + '?callback=JSON_CALLBACK', { params: { 'nocache': new Date().getTime() } });
			}
		}

		// Listen for fully loaded app, send to native AppInitialized()
		jQuery(function() {
			try {
				$rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: jQuery Ready function');
				if ($rootScope.ENV != 'localhost' && typeof AppInitialized == 'function') {
					AppInitialized();
				}
			} catch (err) {
				$rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: jQuery Ready function err: ' + err);
			}
		});

		// Listen bottom screen through postMessage (for development purposes)
		$rootScope.listenBottomScreenInBrowser = function(allowedOrigins) {
			window.addEventListener("message", function (event) {
				if (allowedOrigins && !allowedOrigins.some(function(origin) {
					return event.origin.includes(origin);
				})) {
					return false;
				}
				if (event.data) {
					$rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: listenBottomScreenInBrowser()');
					event.dataParsed = JSON.parse(event.data);
					if (event.dataParsed.messageData) {
						event.messageDataParsed = JSON.parse(event.dataParsed.messageData);
						$rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: listenBottomScreenInBrowser() type: ' + event.dataParsed.type + ' messageData: ' + event.dataParsed.messageData);
						listenTopScreen(event.dataParsed.type, event.dataParsed.messageData);
					} else {
						$rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: listenBottomScreenInBrowser() type: ' + event.dataParsed.type);
						listenTopScreen(event.dataParsed.type);
					}
				}
			}, false);
		}
		$rootScope.listenBottomScreenInBrowser(["http://127.0.0.1:8080", "sportbox", "localhost"]);

		// Template Cache Service
		$templateCache.put('templates/index.html');

		$rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
			$rootScope.toState = toState;
			$rootScope.toStateParams = toStateParams;

			if (Principal.isIdentityResolved()) {
				Auth.authorize();
			}
			$rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: $stateChangeStart()');
			// Update the language
			Language.getCurrent().then(function (language) {
				$translate.use(language);
			});
		});

		$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
			var titleKey = 'global.title';

			$rootScope.previousStateName = fromState.name;
			$rootScope.previousStateParams = fromParams;

			// Set the page title key to the one configured in state or use default one
			if (toState.data.pageTitle) {
				titleKey = toState.data.pageTitle;
			}
			$translate(titleKey).then(function (title) {
				// Change window title with translated one
				$window.document.title = title;
			});
		});

		$rootScope.back = function () {
			// If previous state is 'activate' or do not exist go to 'home'
			if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
				$state.go('home');
			} else {
				$state.go($rootScope.previousStateName, $rootScope.previousStateParams);
			}
		};

		// Get SportBox screens resolution
		$rootScope.getResolution = function () {
			$rootScope.resolution = 'resolution-' + window.screen.width + 'x' + window.screen.height;
		}
		$rootScope.getResolution();

		// Zaokruhlenie na dve desatine smerom nadol (presne do 1e+8)
		$rootScope.floor2 = function(figure, format) {
			try {
				// Ak je pocet znakov pred desatinou ciarkou vacsi ako 9 tak druhe desatine miesto zaokruhli matematicky
				if (Math.round(figure).toString().length > 9) {
						figure = parseFloat(figure);
				} else {
						// Inak ho zaokruhli nadol (chyba v js sa prenasa na 13-16te desatine miesto)
						figure = (parseInt(parseFloat((figure * 100).toPrecision(12))) / 100);
				}
				// Formatuje vysledok (ciarka na miesto bodky)
				if (format) if (format == 1) {
						figure = figure.toFixed(2).replace(".", ",");
				} else {
						figure = figure.toFixed(2);
				}
				return figure;

			} catch (err) {
				$rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: floor2() figure: ' + figure + ' format: ' + format);
				return false;
			}
		}

		// Scroll element inside DOM
		$rootScope.checkScroll = function(part, partH, y, speed) {
			try {
				// Aktualna suradnica
				x = $(part).scrollTop();
		
				// Hranica skorolovania nahor
				if (y == "top" || x + y < 0) {
					x = 0;
				} else {
					// Zistenie spodnej hranice
					var h; // Spodna hranica
					if (partH) {
						h = $(partH)[0].scrollHeight * 1;
						// Virtualne hry maju upravenu spodnu hranicu
					} else {
						$(partH).each(function () {
							h += $(partH).children().height() * 1;
						});
					}
					// Hranica skrolovania nadol (viem urcit vysku priamo)
					if (partH && x + y > h) {
						x = h * 1;
					}
					// Skrolovanie
					else {
						x += y * 1;
					}
				}
				// Posunutie na suradnicu X
				if (!speed) {
					$(part).scrollTop(x);
				} else {
					$(part).queue();
					$(part).animate({scrollTop: x}, speed);
					$(part).dequeue();
				}
			} catch (err) {
				$rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: checkScroll() err: ' + err);
			}
		}
	})

	.config(function ($stateProvider, $urlRouterProvider, $httpProvider, $translateProvider, tmhDynamicLocaleProvider, httpRequestInterceptorCacheBusterProvider, ngRequestCacheDisablerProvider, $sceDelegateProvider) {

		// Enable CSRF
		$httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
		$httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

		// Interceptor will convert all XML responses in to a JavaScript Object
		$httpProvider.interceptors.push('xmlHttpInterceptor');

		// Disable request cache
		ngRequestCacheDisablerProvider.canDisableCache = function (url) {
			//return url.indexOf("https://static.doxxbet.com/") === 0;
			return url.indexOf("http://localhost:5052/") === 0;
		};

		// Cache everything except rest api requests
		httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

		$urlRouterProvider.otherwise('/');
		$stateProvider.state('site', {
			'abstract': true,
			views: {
				'navbar@': {
					templateUrl: 'components/navbar/navbar.html',
					controller: 'NavbarController'
				}
			},
			resolve: {
				authorize: ['Auth',
					function (Auth) {
						return Auth.authorize();
					}
				],
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('global');
					$translatePartialLoader.addPart('language');
					return $translate.refresh();
				}]
			}
		});


		// Initialize angular-translate
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: 'i18n/{lang}/{part}.json'
		});


		$translateProvider.preferredLanguage('en');
		$translateProvider.useCookieStorage();

		tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
		tmhDynamicLocaleProvider.useCookieStorage('NG_TRANSLATE_LANG_KEY');


		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			'https://virtualgames-cf.doxxbet.sk/**',
			'https://vblstaging.aitcloud.de/**',
			'https://vtistaging.aitcloud.de/**',
			'https://cs.betradar.com/ls/widgets/?/doxxbet3/**',
			'https://statistics-cf.doxxbet.sk/statistics/keys',
			'https://screens-svk.doxxbet.sk/**',
			'https://screens-svk.xxbet.sk/**',
			'https://vfstaging.aitcloud.de/**',
			'https://vdrdev.aitcloud.de/**',
			'https://vhc20dev.aitcloud.de/**',
			'https://vflive.aitcloud.de/**',
			'https://vgfrontendstaging.aitcloud.de/**',
			'https://iframe.net4media.net/**',
			'https://static.doxxbet.sk/**',
			'https://app-widget.cdn.doxxbet.sk/**',
			'https://widget-doxxbet-terminal.quickbets-nonprod.sportradar.dev/**',
			'https://widget-doxxbet-terminal.quickbets.sportradar.com/**',
			'https://visionx1.playbetman.com/**',
			'https://visionx.staging.playbetman.com/**',
			'https://iframe.net4media.net/**',
		]);
	})
	.directive('iframeOnload', function() {
		// Directive handles onload iframe event (could be handled in controller scope)
        return {
            scope: {
                callBack: '&iframeOnload'
            },
            link: function(scope, element) {
                element.on('load', function() {
                    return scope.callBack();
                });
            }
        };
    });
